import React from 'react'
import moment from 'moment'
import 'moment/locale/km'
import _ from 'lodash'
import { Button, Modal, Grid, Form } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import DatePicker from '../../components/reports/fields/dateField'

class ReportModal extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selectedBranches: [],
      rielRate: 4100,
      commissionRate: 10,
      invoiceNumber: '',
      invoiceDate: Number(moment().format('x')),
    }
  }

  setInvoiceData = () => {
    const { startFrom, endAt, orders, merchant } = this.props
    const { invoiceDate, rielRate, invoiceNumber, commissionRate, selectedBranches } = this.state

    const subtotal = _.reduce(
      orders,
      (accum, order) => {
        const { merchantName, branchId, branchName, subtotal = 0 } = order

        let label = merchantName.trim()

        if (selectedBranches.length <= 0) {
          accum[label] = subtotal + (accum[label] || 0)
        } else if (selectedBranches.includes(branchId)) {
          label = (label + ` - ${branchName}`).trim()
          accum[label] = subtotal + (accum[label] || 0)
        }

        return accum
      },
      {}
    )

    const invoiceDateEn = moment(invoiceDate).format('DD MMM YYYY')
    const invoiceDateKh = moment(invoiceDate)
      .locale('km')
      .format('DD MMM YYYY')
    const paramsObj = {
      startFrom: moment(startFrom).format('DD MMM'),
      endAt: moment(endAt).format('DD MMM YYYY'),

      subtotal: subtotal,
      officialInfo: merchant.official_info,
      rielRate,
      invoiceDateEn,
      invoiceDateKh,
      invoiceNumber,
      commissionRate,
    }

    localStorage.setItem('invoiceState', JSON.stringify(paramsObj))
  }
  render() {
    const { modalReportVisible, onFieldChange, merchant } = this.props
    const { invoiceDate, rielRate, commissionRate, invoiceNumber, selectedBranches } = this.state

    const branchSelectionList =
      merchant &&
      _.map(merchant.branches, (branch, branchId) => ({
        value: branchId,
        text: `${merchant.name} - ${branch.name}`,
      }))

    const invoices = [
      {
        label: 'Tax',
        path: { pathname: `/restaurants/invoice/tax` },
      },
      {
        label: 'Commercial',
        path: { pathname: `/restaurants/invoice/commercial` },
      },
      {
        label: 'Market',
        path: { pathname: `/restaurants/invoice/market` },
      },
    ]

    return (
      <Modal
        open={modalReportVisible}
        onClose={() => {
          onFieldChange('modalReportVisible', false)
        }}
        size="small"
      >
        <Modal.Header>Invoice</Modal.Header>
        <Modal.Content>
          <Form style={{ marginTop: 10 }}>
            <Form.Group widths="2">
              <Form.Input
                onChange={e => this.setState({ rielRate: e.target.value })}
                value={rielRate}
                label="Riel's Rate"
                icon="money bill alternate"
              />

              <Form.Input
                onChange={e => this.setState({ commissionRate: e.target.value })}
                value={commissionRate}
                label="Commission Rate"
                icon="percent alternate"
              />
            </Form.Group>
            <Form.Group widths="2">
              <Form.Input
                required
                label="Invoice Number"
                onChange={e => this.setState({ invoiceNumber: e.target.value })}
                value={invoiceNumber}
              />
              <DatePicker
                label="Invoice Date"
                onChange={value => this.setState({ invoiceDate: value })}
                value={invoiceDate}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Select
                multiple
                label="Split by Branches"
                options={branchSelectionList}
                placeholder="All Branch"
                value={selectedBranches}
                onChange={(e, { value }) => {
                  this.setState({ selectedBranches: value })
                }}
              />
            </Form.Group>
          </Form>

          <Grid style={{ marginTop: 10 }}>
            <Grid.Row columns={3}>
              {invoices.map(invoiceData => (
                <Grid.Column style={{ textAlign: 'center' }} key={invoiceData.label}>
                  <Link target="_blank" to={invoiceData.path}>
                    <Button size="big" onClick={this.setInvoiceData}>
                      {invoiceData.label}
                    </Button>
                  </Link>
                </Grid.Column>
              ))}
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => onFieldChange('modalReportVisible', false)}>close</Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default ReportModal



// WEBPACK FOOTER //
// ./src/components/invoice/ReportModal.js